import React, { Component, lazy, Suspense } from 'react';
import { IntlProvider } from 'react-intl';
import { connect } from 'react-redux';
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom';
import ColorSwitcher from './components/common/ColorSwitcher';
import NotificationContainer from './components/common/react-notifications/NotificationContainer';
import { isDemo, isMultiColorActive } from './constants/defaultValues';
import { getDirection } from './helpers/Utils';
import AppLocale from './lang';
import MetaTags from 'react-meta-tags';
import { Helmet } from "react-helmet";

const ViewMain = lazy(() => import('./views'));
const ViewApp = lazy(() => import('./views/app'));
const ViewUser = lazy(() => import('./views/user'));
const ViewError = lazy(() => import('./views/error'));
const ViewActivate = lazy(() => import('./views/activate'));
const ViewSetpassword = lazy(() => import('./views/setpassword'));
const Livedetail = lazy(() => import('./views/livedetail'))
const ViewLive = lazy(() => import('./views/live'));


// import ViewMain from './views';
// import ViewApp from './views/app';
// import ViewUser from './views/user';
// import ViewError from './views/error';
// import ViewActivate from './views/activate';
// import ViewSetpassword from './views/setpassword';
// import Livedetail from './views/livedetail'

const AuthRoute = ({ component: Component, authUser, ...rest }) => {

  return (
    <Route
      {...rest}
      render={props =>
        authUser || isDemo ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: '/app/home',
              state: { from: props.location }
            }}
          />
        )
      }
    />
  );
}

class App extends Component {
  constructor(props) {
    super(props);
    const direction = getDirection();
    if (direction.isRtl) {
      document.body.classList.add('rtl');
      document.body.classList.remove('ltr');
    } else {
      document.body.classList.add('ltr');
      document.body.classList.remove('rtl');
    }
  }

  render() {
    const { locale, loginUser } = this.props;
    const currentAppLocale = AppLocale[locale];
    return (
      <div className="h-100">

        {/* <MetaTags>
        
          <meta property="og:title" content='test meta' />
          <meta property="og:image" content="https://storage.tpchannel.org/ott-assets/org/TV-1.jpg" />

        </MetaTags> */}

        {/* <Helmet>
          <meta property="og:title" content='test meta' />
          <meta property="og:image" content="https://storage.tpchannel.org/ott-assets/org/TV-1.jpg" />

        </Helmet> */}

        <IntlProvider
          locale={currentAppLocale.locale}
          messages={currentAppLocale.messages}
        >
          <React.Fragment>
            <NotificationContainer />
            {isMultiColorActive && <ColorSwitcher />}
            <Suspense fallback={<div className="loading" />}>
              <Router>
                <Switch>
                  {/* <AuthRoute */}
                  <Route
                    path="/app"
                    // authUser={loginUser}
                    // component={ViewApp}
                    render={props => <ViewApp {...props} />}
                  />
                  <Route
                    path="/mobile"
                    // authUser={loginUser}
                    // component={ViewApp}
                    render={props => <ViewLive {...props} />}
                  />
                  <Route
                    path="/user"
                    render={props => <ViewUser {...props} />}
                  />
                  <Route
                    path="/error"
                    exact
                    render={props => <ViewError {...props} />}
                  />
                  <Route
                    path="/activate/:id"
                    exact
                    render={props => <ViewActivate {...props} />}
                  />
                  <Route
                    path="/setpassword/:id"
                    exact
                    render={props => <ViewSetpassword {...props} />}
                  />
                  <Route
                    path="/ghioMVjNGSStqzoedvBhNOGiFBi3Bf0qkni0Kw8ctiA="
                    exact
                    render={(props) => <Livedetail {...props} />}
                  />
                  <Route
                    path="/"
                    exact
                    render={props => <ViewMain {...props} />}
                  />
                  {/* <Redirect to="/error" /> */}
                </Switch>
              </Router>
            </Suspense>
          </React.Fragment>
        </IntlProvider>
      </div>
    );
  }
}

const mapStateToProps = ({ authUser, settings }) => {

  const { user: loginUser } = authUser;
  const { locale } = settings;

  return {
    loginUser,
    locale
  };
};
const mapActionsToProps = {};

export default connect(
  mapStateToProps,
  mapActionsToProps
)(App);
